import React, { PureComponent } from 'react';
import { Image, Text, View } from '@react-pdf/renderer';
import { styles } from 'app/components/panels/inp/pdf/PdfDocument';

export class NatTracksMap extends PureComponent<{ natTracks: string }> {
    render() {
        return (
            <View style={{ paddingTop: 10 }}>
                <Text style={styles.section_title}>NAT Tracks</Text>
                {this.props.natTracks ? <Image source={this.props.natTracks} /> : this.renderPlaceHolder()}
            </View>
        );
    }

    private renderPlaceHolder() {
        return (
            <Text style={{ fontSize: 15, justifyContent: 'center', padding: 10 }}>
                The NAT Tracks MAP image is not available.
            </Text>
        );
    }
}
